import { Component, ChangeDetectorRef, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { CommonService, CrudComponent } from 'wire-frame';
import { HttpClient, HttpHeaders } from "@angular/common/http";

import { forkJoin, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { EMPTY } from 'rxjs';
import { switchMap } from 'rxjs/operators';

import { TagModule } from 'primeng/tag';
import { ToggleButtonModule } from 'primeng/togglebutton';
import { DropdownModule } from 'primeng/dropdown';
import { ToolbarModule } from 'primeng/toolbar';
import { ToastModule } from 'primeng/toast';
import { EditorModule } from 'primeng/editor';


import { ButtonModule } from 'primeng/button';
import { TabViewModule } from 'primeng/tabview';
import { InputTextModule } from 'primeng/inputtext';
import { FileUploadModule } from 'primeng/fileupload';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { AccordionModule } from 'primeng/accordion';
import { ScrollPanelModule } from 'primeng/scrollpanel';
import { AutoCompleteModule } from "primeng/autocomplete";
import { DialogModule } from 'primeng/dialog';
import { TooltipModule } from 'primeng/tooltip';
import { FloatLabelModule } from 'primeng/floatlabel';
import { SidebarModule } from 'primeng/sidebar';

import { AppointmentService } from '../../../service/admin/appointment.service';
import { CalendarComponent } from '../calendar/calendar.component';  // ✅ standalone Calendar
import { ClinicService } from '../../../service/admin/clinic.service';
import { UserService } from '../../../service/admin/user.service';
import { PatientRegistrationService } from '../../../service/admin/patient-registration.service';
import { PrescriptionsService} from '../../../service/admin/prescriptions.service';

import { ApiService } from '../../../service/admin/api.service';
import { WorkContextService } from '../../../service/admin/work-context.service';
import { DeskChatService } from '../../../service/admin/desk-chat.service';
import { Subscription } from 'rxjs';
import { distinctUntilChanged } from 'rxjs/operators';
import { todayDateString, formatDisplayTime } from '../../../utils/clinic-date.util';
import { ToasterService } from '../../../service/common/toaster.service';
import {
  DELIVERY_TYPE_OPTIONS,
  DeliveryType,
  FlowCounts,
  FlowFilter,
  deliveryBadgeIcon,
  deliveryTypeLabel,
  deliveryTypeShortLabel,
  matchesFlowFilter,
  resolveDeliveryType,
} from '../../../utils/delivery-type.util';
import {
  MedicineIntent,
  medicineIntentShortLabel,
  receptionNoteTooltip,
} from '../../../utils/medicine-intent.util';

@Component({
  selector: 'app-appointment',
  standalone: true,
  imports: [
    FormsModule,
    CommonModule,
    TagModule,
    ToggleButtonModule,
    DropdownModule,
    ToolbarModule,
    ToastModule,
    EditorModule,
    CalendarComponent, 
    TabViewModule,
    InputTextModule,  
    FileUploadModule,
    InputTextareaModule,
    AccordionModule,
    ScrollPanelModule,
    ButtonModule,
    AutoCompleteModule,
    DialogModule,
    TooltipModule,
    FloatLabelModule,
    SidebarModule,
    
    // ✅ directly imported, no need CalendarModule
  ],
  providers: [
    CommonService,
    AppointmentService,
    ClinicService,
    UserService,
    PatientRegistrationService,
    ApiService
  ],
  templateUrl: './appointment.component.html',
  styleUrls: ['./appointment.component.scss', './appointment-dispense-dialog.scss']
})
export class AppointmentComponent implements OnInit, OnDestroy {
  public checked: boolean = false;
  public AppointmentList = [];
  pationtIndex: number = 0;
  medicineIndex: number = 0;
  public editRecord = null;
  public doctorsList: any[] = [];
  public doctor_id: any = null;
  public showFilters: boolean = false;
  public clinicList: any[] = [];
  public clinic_id: any = null;

  applyContext() {}
  public Appointment = {
    id: 0,
    country: '',
    flag_svg: '',
    description: '',
    detail_description: '',
    price: '',
    footer: '',
    visa_type: '',
    status: true,
    service_fee: ''
  };

  public patient = {
    name: '',
    salutation: '',
    
  }

  public visaTypes = [
    { label: 'E-VISA', value: 'E-VISA' },
    { label: 'DAC', value: 'DAC' },
    { label: 'ETA', value: 'ETA' },
    { label: 'EVOA', value: 'EVOA' },
    { label: 'PAR', value: 'PAR' },
    { label: 'STICKER VISA', value: 'STICKER VISA' }];

  public closeFormEvent: boolean = false;
  public openDeletePopup: any = null;
  public activeMenu: string = 'personal';

  selectedDate: string = todayDateString();
  public queue: any[] = [];
  public consultationFlowFilter: FlowFilter = 'all';
  public consultationQueueSearchTerm = '';
  public medicineQueueFlowFilter: FlowFilter = 'all';
  public medicineQueueSearchTerm = '';
  readonly deliveryTypeOptions = DELIVERY_TYPE_OPTIONS;
  public completedQueue: any[] = [];
  public medicineQueue: any[] = [];
  public allMedicineQueue: any[] = [];
  public patientsList: any[] = [];
  selectedPatient: any = {};
  visible: boolean = false;
  completeConfirmVisible = false;
  pendingCompletePatient: any = null;
  switchPatientConfirmVisible = false;
  pendingSwitchPatient: any = null;
  pendingPreviousPatient: any = null;

  private contextSubscription?: Subscription;
  private contextReady = false;

  filteredRecords: any[] = [];

  isPatientVisible: boolean = false;
  isMedicineVisible: boolean = false;
  private readonly checkInUndoMs = 5000;
  private pendingCheckInTimers = new Map<number, any>();
  private waitingTimeInterval: any;
  public waitingTimeTick = Date.now();

  @ViewChild(CalendarComponent) appointmentCalendar?: CalendarComponent;
  @ViewChild('consultationQueueSearchInput') consultationQueueSearchInput?: ElementRef<HTMLInputElement>;

  private apiUrl: string | undefined;


  constructor(
    public common: CommonService,
    private toaster: ToasterService,
    private appointmentService: AppointmentService,
    private clinicService: ClinicService,
    private userService: UserService,
    private patientRegistrationService: PatientRegistrationService,
    private http: HttpClient,
    private cdr: ChangeDetectorRef,
    private prescriptionsService: PrescriptionsService,
    private apiService: ApiService,
    private workContext: WorkContextService,
    private deskChat: DeskChatService,
  ) {
    this.apiUrl = this.apiService.getBaseUrl();
    this.common.breadCrum = {
      title: 'Visa Card Master',
      icon: 'user',
      list: ['Visa Card Master'],
    };
    this.common.setCrudTableHeaders([
      { title: 'Country', val: 'country', id: 'id', showColumn: true, filterColmn: true, order: 'asc', searchColumn: true, type: 'string', globalSearch: true },
      { title: 'Visa Type', val: 'typeValue', id: 'typeValue', showColumn: true, filterColmn: true, order: 'asc', searchColumn: true, type: 'string', globalSearch: true },
      { title: 'Status', val: 'status', id: 'status', showColumn: true, filterColmn: true, order: 'asc', searchColumn: true, type: 'string', globalSearch: true },
      { title: 'Price', val: 'price', id: 'price', showColumn: true, filterColmn: true, order: 'asc', searchColumn: true, type: 'string', globalSearch: true },
      { title: 'Service Fee', val: 'service_fee', id: 'service_fee', showColumn: true, filterColmn: true, order: 'asc', searchColumn: true, type: 'string', globalSearch: true },
      { title: 'Footer', val: 'footer', id: 'footer', showColumn: true, filterColmn: true, order: 'asc', searchColumn: true, type: 'string', globalSearch: true }
    ]);
    this.common.setCrudActions([
      { title: '', icon: 'pi-pencil', classArr: 'me-2', tooltip: 'Update Visa Card' },
      { title: '', icon: 'pi-trash', tooltip: 'Delete Visa Card' }
    ]);
  }

  private pendingDeskPatientId: number | null = null;
  private awaitingDeskPatient = false;

  ngOnInit() {
    this.contextSubscription = new Subscription();
    this.contextSubscription.add(
      this.deskChat.openPatient$.subscribe((patientId) => {
        if (!patientId) {
          return;
        }
        this.pendingDeskPatientId = patientId;
        if (this.tryOpenDeskChatPatient()) {
          return;
        }
        this.awaitingDeskPatient = true;
        this.loadQueue();
      }),
    );

    this.contextSubscription.add(this.workContext.ensureOptionsLoaded().subscribe());

    this.contextSubscription.add(
      this.workContext.context$
        .pipe(distinctUntilChanged((a, b) => a.clinicId === b.clinicId && a.doctorId === b.doctorId))
        .subscribe((ctx) => {
          if (!ctx.clinicId || !ctx.doctorId) {
            return;
          }

          if (this.contextReady) {
            this.loadQueue();
            this.loadMedicineQueue();
            this.loadAllMedicineQueue();
          } else {
            this.contextReady = true;
            this.loadQueue();
          }
        }),
    );

    this.waitingTimeInterval = setInterval(() => {
      this.waitingTimeTick = Date.now();
      this.cdr.markForCheck();
    }, 30000);
  }

  ngOnDestroy() {
    this.deskChat.setAttachablePatient(null);
    this.contextSubscription?.unsubscribe();
    this.pendingCheckInTimers.forEach((timerId) => clearTimeout(timerId));
    this.pendingCheckInTimers.clear();
    if (this.waitingTimeInterval) {
      clearInterval(this.waitingTimeInterval);
    }
  }

  private getQueueSlotMinutes(): number {
    return this.clinicService.getSlotDurationMinutes(this.workContext.getClinicId());
  }

  private getAuthHeaders() {
    const token = localStorage.getItem('jwtToken');
    return {
      headers: new HttpHeaders({
        'Authorization' : `Bearer ${token}`
      })
    }
  }

  getAppointments() {
    this.appointmentService.getAppointment().subscribe((res: any) => {
      this.AppointmentList = res.data;
      this.AppointmentList.forEach((Appointment: any) => {
        Appointment['typeValue'] = Appointment['label']['value'];
      });
    });
  }

  closeForm() {
    this.clearForm();
    this.closeFormEvent = true;
    setTimeout(() => {
      this.closeFormEvent = false;
    }, 1);
  }

  clearForm() { 
    this.Appointment = {
      id: 0,
      country: '',
      flag_svg: '',
      description: '',
      detail_description: '',
      price: '',
      footer: '',
      visa_type: '',
      status: true,
      service_fee: '',
    };
  }

  processAppointments() {
    if (this.Appointment?.id) {
      this.updateAppointment();
    } else {
      this.addAppointment();
    }
  }

  addAppointment() {
    this.appointmentService.addAppointment(this.Appointment).subscribe({
      next: () => {
        this.toaster.success('Visa Card added successfully');
        this.getAppointments();
        this.closeForm();
      },
      error: (err) => {
        let detailMsg = 'Error adding Visa Card';
        if (err.status === 422 && err.error && err.error.errors && err.error.errors.start_time) {
          detailMsg = err.error.errors.start_time[0];
        }
        this.toaster.error(detailMsg);
      }
    });
  }

  updateAppointment() {
    this.appointmentService.updateAppointment(this.Appointment).subscribe({
      next: () => {
        this.toaster.success('Visa Card updated successfully');
        this.getAppointments();
        this.closeForm();
      },
      error: (err) => {
        let detailMsg = 'Error updating Visa Card';
        if (err.status === 422 && err.error && err.error.errors && err.error.errors.start_time) {
          detailMsg = err.error.errors.start_time[0];
        }
        this.toaster.error(detailMsg);
      }
    });
  }

  updatePrescription() {
    this.prescriptionsService.updatePrescriptions(this.Appointment).subscribe(() => {
      this.toaster.success('Prescription updated successfully');
      this.getAppointments();
      this.closeForm();
    });
  }

  deleteAppointment(item: any) {
    this.appointmentService.deleteAppointment(item).subscribe(() => {
      this.toaster.success('Visa Card deleted successfully');
      this.getAppointments();
      this.closeForm();
    })
  }

  deleteRecord(event: any) {
    if(event) {
      this.deleteAppointment(event);
    }
  }

  handleEvent(event: any) {
    if(event.action.tooltip == "Update Visa Card") {
      this.editRecord = event.data;
      this.Appointment = event.data;
      setTimeout(() => { this.editRecord = null; }, 1);
    } else if(event.action.tooltip == "Delete Visa Card") {
      this.editRecord = event.data;
      this.delRecPopupOpen({title: this.editRecord?.['country'], obj: this.editRecord});
    }
  }

  delRecPopupOpen(item: any) {
    this.openDeletePopup = item;
    setTimeout(() => {
      this.openDeletePopup = null;
    }, 1);
  }

  // getColorClass(status: string): string {
  //   switch (status) {
  //     case 'in progress': return 'bg-light-yellow';
  //     case 'completed': return 'bg-light-green';
  //     case 'scheduled': return 'bg-light-blue';
  //     case 'cancelled': return 'bg-light-red';
  //     case 'medicine': return 'bg-light-purple';
  //     default: return 'bg-light-yellow';
  //   }
  // }

  getColorClass(status: string): string {
    switch (status) {
      case 'scheduled': return 'status-scheduled';
      case 'in progress': return 'status-in-progress';
      case 'checked in': return 'status-checked-in';
      case 'completed': return 'status-completed';
      case 'cancelled': return 'status-cancelled';
      case 'medicine': return 'status-medicine';
      default: return '';
    }
  }

  // loadQueue() {
  //   const clinicId = sessionStorage.getItem('clinic_id') || '1';
  //   const doctorId = sessionStorage.getItem('doctor_id') || '1';

  //   // ✅ Check if clinic or doctor not selected
  //   if (!clinicId || !doctorId) {
  //     this.toaster.add({
  //       severity: 'warn',
  //       summary: 'Missing Selection',
  //       detail: 'Select the clinic and doctor',
  //     });
  //   }

  //   const date = this.selectedDate || new Date().toISOString().slice(0, 10);

  //   this.appointmentService.getQueue({
  //     clinic_id: clinicId,
  //     doctor_id: doctorId,
  //     date: date,
  //     // date: "2025-09-12",
  //     slot: 60
  //   }).subscribe((res: any) => {
  //     if (res.success) {
  //       const appointments = res.data.slots.flatMap((slot: any) =>
  //         slot.appointments.map((appt: any) => ({
  //           appointment_id: appt.id,
  //           patient_id: appt.patient_id,
  //           clinic_id: appt.clinic_id,
  //           doctor_id: appt.doctor_id,
  //           time: appt.start_time,
  //           status: appt.status,
  //           medicine_collection: appt.medicine_collection,
  //         }))
  //       );

  //       // Collect all patient IDs
  //       const patientIds = appointments.map((a: any) => a.patient_id);

  //       // Fetch all patient data in one request
  //       this.patientRegistrationService.getPatientsBatch(patientIds)
  //         .subscribe((patientRes: any) => {
  //           if (patientRes.success) {
  //             const patientsMap = new Map();
  //             patientRes.data.forEach((p: any) => patientsMap.set(p.id, p));

  //             // Map appointments to patients
  //             this.queue = appointments.map((appt: any) => {
  //               const patient = patientsMap.get(appt.patient_id);
  //               return {
  //                 name: `${patient.salutation ?? ''} ${patient.full_name}`,
  //                 full_name: patient.full_name,
  //                 time: appt.time,
  //                 status: appt.status,
  //                 contact_number: patient.contact_number,
  //                 salutation: patient.salutation,
  //                 is_free: patient.is_free,
  //                 card_id: patient.card_id,
  //                 age: patient.age,
  //                 appointment_id: appt.appointment_id,
  //                 clinic_id: appt.clinic_id,
  //                 doctor_id: appt.doctor_id,
  //                 referred_by: patient.referred_by,
  //                 referred_by_dr: patient.referred_by_dr,
  //                 occupation: patient.occupation,
  //                 medicine_collection: appt.medicine_collection,
  //               };
  //             });

  //             // Sort by time once
  //             this.queue.sort((a, b) => a.time.localeCompare(b.time));
  //             // console.log('Loaded consultation queue:', this.queue);
  //           }
  //         });
  //     }
  //   });
  // }

  loadQueue() {
    const clinicId = this.workContext.getClinicIdString();
    const doctorId = this.workContext.getDoctorIdString();

    if (!clinicId || !doctorId) {
      this.toaster.warn('Select the clinic and doctor', 'Missing Selection');
      return;
    }

    const date = this.selectedDate || todayDateString();

    this.appointmentService.getQueue({
      clinic_id: clinicId,
      doctor_id: doctorId,
      date: date,
      slot: this.getQueueSlotMinutes()
    }).subscribe((res: any) => {

      if (!res.success) return;

      const appointments = res.data.slots.flatMap((slot: any) =>
        slot.appointments.map((appt: any) => ({
          appointment_id: appt.id,
          patient_id: appt.patient_id,
          clinic_id: appt.clinic_id,
          doctor_id: appt.doctor_id,
          time: appt.start_time,
          status: appt.status,
          checked_in_at: appt.checked_in_at,
          medicine_collection: appt.medicine_collection,
          delivery_type: appt.delivery_type || (appt.is_courier ? 'home_delivery' : null),
          is_courier: appt.is_courier || false,
          appointment_notes: appt.notes || '',
          medicine_intent: appt.medicine_intent ?? null,
        }))
      );

      const patientIds = [...new Set(appointments.map((a: any) => a.patient_id))] as number[];

      this.patientRegistrationService.getPatientsBatch(patientIds)
        .subscribe((patientRes: any) => {

          if (!patientRes.success) return;

          const patientsMap = new Map<number, any>();
          patientRes.data.forEach((p: any) => patientsMap.set(p.id, p));

          // RESET QUEUES
          this.queue = [];
          this.completedQueue = [];

          appointments.forEach((appt: any) => {
            const patient = patientsMap.get(appt.patient_id);
            if (!patient) return;

            const mapped = {
              name: `${patient.salutation ?? ''} ${patient.full_name}`.trim(),
              full_name: patient.full_name,
              time: appt.time,
              status: appt.status,
              checked_in_at: appt.checked_in_at,
              contact_number: patient.contact_number,
              salutation: patient.salutation,
              is_free: patient.is_free,
              card_id: patient.card_id,
              age: patient.age,
              appointment_id: appt.appointment_id,
              clinic_id: appt.clinic_id,
              doctor_id: appt.doctor_id,
              referred_by: patient.referred_by,
              referred_by_dr: patient.referred_by_dr,
              occupation: patient.occupation,
              personal_dues: Number(patient.personal_dues ?? 0) || 0,
              medicine_collection: appt.medicine_collection,
              delivery_type: appt.delivery_type || (appt.is_courier ? 'home_delivery' : null),
          is_courier: appt.is_courier || false,
              appointment_notes: appt.appointment_notes || '',
              medicine_intent: appt.medicine_intent ?? null,
              patient_id: patient.id,
              patient_number: patient.patient_number || '',
              card_number: String(patient.patient_number || '').split('-')[0] || '',
            };

            // 🔥 HARD SEPARATION
            if (appt.status === 'completed') {
              this.completedQueue.push(mapped);
            } else {
              this.queue.push(mapped);
            }
          });

          // SORT BOTH
          this.queue.sort((a, b) => a.time.localeCompare(b.time));
          this.completedQueue.sort((a, b) => a.time.localeCompare(b.time));
          if (this.awaitingDeskPatient) {
            this.awaitingDeskPatient = false;
            if (!this.tryOpenDeskChatPatient()) {
              this.pendingDeskPatientId = null;
              this.deskChat.clearOpenRequest();
              this.toaster.info('That patient is not in today\'s queue.', 'Desk chat');
            }
          }
        });
    });
  }


  loadMedicineQueue() {
    const clinicId = this.workContext.getClinicIdString();
    const doctorId = this.workContext.getDoctorIdString();

    if (!clinicId || !doctorId) {
      this.toaster.warn('Select the clinic and doctor', 'Missing Selection');
      // return; // stop execution
    }

    const date = this.selectedDate || todayDateString();

    this.appointmentService.getMedicineQueue({
      clinic_id: clinicId,
      doctor_id: doctorId,
      date: date,
      // date: "2025-09-12",
      slot: this.getQueueSlotMinutes()
    }).subscribe((res: any) => {
      if (res.success) {
        const appointments = res.data.slots.flatMap((slot: any) =>
          slot.appointments.map((appt: any) => ({
            appointment_id: appt.id,
            patient_id: appt.patient_id,
            clinic_id: appt.clinic_id,
            doctor_id: appt.doctor_id,
            time: appt.start_time,
            status: appt.status,
            prescription_id: appt.latest_prescription_id,
          }))
        );

        // Collect all patient IDs
        const patientIds = appointments.map((a: any) => a.patient_id);

        // Fetch all patient data in one request
        this.patientRegistrationService.getPatientsBatch(patientIds)
          .subscribe((patientRes: any) => {
            if (patientRes.success) {
              const patientsMap = new Map();
              patientRes.data.forEach((p: any) => patientsMap.set(p.id, p));

              // Map appointments to patients
              this.medicineQueue = appointments.map((appt: any) => {
                // console.log('appt:', appt);
                const patient = patientsMap.get(appt.patient_id);
                return {
                  id: patient.id,
                  prescription_id: appt.prescription_id,
                  name: `${patient.salutation} ${patient.full_name}`,
                  full_name: patient.full_name,
                  time: appt.time,
                  status: appt.status,
                  contact_number: patient.contact_number,
                  salutation: patient.salutation,
                  is_free: patient.is_free,
                  card_id: patient.card_id,
                  age: patient.age,
                  appointment_id: appt.appointment_id,
                  clinic_id: appt.clinic_id,
                  doctor_id: appt.doctor_id,
                  referred_by: patient.referred_by,
                  referred_by_dr: patient.referred_by_dr,
                  occupation: patient.occupation,
                  date: date,
                  medicines: '',
                  personal_dues: 0,
                  visit_fees: 0,
                  received_online: 0,
                  received_cash: 0,
                  card_dues: 0,
                };
              });

              // Now fetch prescriptions (all) for each patient asynchronously
              this.medicineQueue.forEach((queueItem) => {
                this.prescriptionsService.getPrescriptionsByPatientId(queueItem.id)
                  .subscribe((res: any) => {
                    if (res.success && res.data) {
                      const filteredRecords = res.data;

                      // Attach history if needed
                      queueItem.history = filteredRecords;

                      // Take the latest prescription (assuming index 0 is latest)
                      const latest = filteredRecords.length ? filteredRecords[0] : {};

                      // Attach latest medicines
                      queueItem.medicines = latest.medicines || '';

                      // ✅ Calculate personal dues using both records + current
                      // queueItem.personal_dues = this.calculatePersonalDues(filteredRecords, latest);
                      queueItem.personal_dues = latest.personal_dues || 0;

                      // Attach financials from latest prescription
                      queueItem.visit_fees = latest.visit_fees || 0;
                      queueItem.received_online = latest.received_online || 0;
                      queueItem.received_cash = latest.received_cash || 0;

                      // ✅ Calculate card dues dynamically
                      queueItem.card_dues = latest.card_dues || 0;
                    } else {
                      // No prescriptions found
                      queueItem.medicines = '';
                      queueItem.personal_dues = 0;
                      queueItem.visit_fees = 0;
                      queueItem.received_online = 0;
                      queueItem.received_cash = 0;
                      queueItem.card_dues = 0;
                      queueItem.history = [];
                    }
                  });
              });


              //! second
              // 1. Handle the case of an empty queue to avoid errors.
            //   if (!this.medicineQueue || this.medicineQueue.length === 0) {
            //     return; // Nothing to do
            //   }

            //   // 2. Create an array of API calls (observables) without subscribing yet.
            //   const prescriptionRequests = this.medicineQueue.map(queueItem =>
            //     this.prescriptionsService.getLatestPrescription(queueItem.id).pipe(
            //       // If one request fails, forkJoin will fail.
            //       // catchError prevents this by returning a successful response with an error flag.
            //       catchError(error => of({ success: false, error }))
            //     )
            //   );

            // // 3. Use forkJoin to execute all requests in parallel.
            // forkJoin(prescriptionRequests).subscribe((responses: any[]) => {
            //   // 4. Loop through the responses and update your original queue.
            //   // The 'responses' array matches the order of 'this.medicineQueue'.
            //   responses.forEach((presRes, index) => {
            //     const queueItem = this.medicineQueue[index]; // Get the corresponding original item

            //     if (presRes && presRes.success && presRes.data) {
            //       // Attach medicines and other data to the patient in the queue
            //       queueItem.medicines = presRes.data.medicines || '';
            //       queueItem.personal_dues = presRes.data.personal_dues || 0;
            //       queueItem.visit_fees = presRes.data.visit_fees || 0;
            //       queueItem.received_online = presRes.data.received_online || 0;
            //       queueItem.received_cash = presRes.data.received_cash || 0;
            //       queueItem.card_dues = presRes.data.card_dues || 0;
            //     }
            //   });
            // });

            //! first
            // Now fetch prescriptions (all) for each patient asynchronously
            // this.medicineQueue.forEach((queueItem) => {
            //   this.prescriptionsService.getPrescriptionsByPatientId(queueItem.id)
            //     .subscribe((res: any) => {
            //       if (res.success && res.data) {
            //         const prescriptions = res.data;

            //         // Attach history if needed
            //         queueItem.history = prescriptions;

            //         // Take the latest prescription (assuming index 0 is latest)
            //         const latest = prescriptions.length ? prescriptions[0] : {};

            //         // Attach latest medicines
            //         queueItem.medicines = latest.medicines || '';

            //         // ✅ Calculate personal dues using both records + current
            //         queueItem.personal_dues = this.calculatePersonalDues(prescriptions, latest);

            //         // Attach financials from latest prescription
            //         queueItem.visit_fees = latest.visit_fees || 0;
            //         queueItem.received_online = latest.received_online || 0;
            //         queueItem.received_cash = latest.received_cash || 0;

            //         // ✅ Calculate card dues dynamically
            //         queueItem.card_dues = latest.card_dues || 0;
            //       } else {
            //         // No prescriptions found
            //         queueItem.medicines = '';
            //         queueItem.personal_dues = 0;
            //         queueItem.visit_fees = 0;
            //         queueItem.received_online = 0;
            //         queueItem.received_cash = 0;
            //         queueItem.card_dues = 0;
            //         queueItem.history = [];
            //       }
            //     });
            // });

              // Sort by time once
              this.medicineQueue.sort((a, b) => a.time.localeCompare(b.time));
              // console.log('Loaded medicine queue:', this.medicineQueue);
            }
          });
      }
    });
  }

  // loadAllMedicineQueue() {
  //   const clinicId = sessionStorage.getItem('clinic_id') || '1';
  //   const doctorId = sessionStorage.getItem('doctor_id') || '1';

  //   if (!clinicId || !doctorId) {
  //     this.toaster.add({
  //       severity: 'warn',
  //       summary: 'Missing Selection',
  //       detail: 'Select the clinic and doctor',
  //     });
  //     return;
  //   }

  //   this.appointmentService.getAllMedicineQueue({
  //     clinic_id: clinicId,
  //     doctor_id: doctorId,
  //   }).subscribe((res: any) => {
  //     if (res.success && res.data && res.data.appointments) {
  //       const appointments = res.data.appointments.map((appt: any) => ({
  //         appointment_id: appt.id,
  //         patient_id: appt.patient_id,
  //         clinic_id: appt.clinic_id,
  //         doctor_id: appt.doctor_id,
  //         date: appt.appointment_date,
  //         formatdate: this.formatDate(appt.appointment_date),
  //         time: this.formatTime(appt.start_time),
  //         status: appt.status,
  //         medicine_collection: appt.medicine_collection,
  //         prescription_id: appt.latest_prescription_id,
  //       }));

  //       const patientIds = appointments.map((a: any) => a.patient_id);

  //       // ✅ Fetch all patient details in one go
  //       // this.patientRegistrationService.getPatientsBatch(patientIds)
  //       //   .subscribe((patientRes: any) => {
  //       //     if (patientRes.success && patientRes.data) {
  //       //       const patientsMap = new Map();
  //       //       patientRes.data.forEach((p: any) => patientsMap.set(p.id, p));

  //       //       // ✅ Merge patient + appointment data
  //       //       this.allMedicineQueue = appointments.map((appt: any) => {
  //       //         const patient = patientsMap.get(appt.patient_id);
  //       //         return {
  //       //           id: patient.id,
  //       //           prescription_id: appt.prescription_id,
  //       //           name: `${patient.salutation} ${patient.full_name}`,
  //       //           full_name: patient.full_name,
  //       //           time: appt.time,
  //       //           date: appt.date,
  //       //           formatdate: appt.formatdate,
  //       //           status: appt.status,
  //       //           contact_number: patient.contact_number,
  //       //           salutation: patient.salutation,
  //       //           is_free: patient.is_free,
  //       //           card_id: patient.card_id,
  //       //           age: patient.age,
  //       //           appointment_id: appt.appointment_id,
  //       //           clinic_id: appt.clinic_id,
  //       //           doctor_id: appt.doctor_id,
  //       //           referred_by: patient.referred_by,
  //       //           referred_by_dr: patient.referred_by_dr,
  //       //           occupation: patient.occupation,
  //       //           medicines: '',
  //       //           personal_dues: 0,
  //       //           visit_fees: 0,
  //       //           received_online: 0,
  //       //           received_cash: 0,
  //       //           card_dues: 0,
  //       //           history: [],
  //       //         };
  //       //       });

  //       //       // ✅ Fetch prescriptions for each patient
  //       //       this.allMedicineQueue.forEach((queueItem) => {
  //       //         this.prescriptionsService.getPrescriptionsByPatientId(queueItem.id)
  //       //           .subscribe((res: any) => {
  //       //             if (res.success && res.data) {
  //       //               const prescriptions = res.data;
  //       //               const latest = prescriptions.length ? prescriptions[0] : {};

  //       //               queueItem.history = prescriptions;
  //       //               queueItem.medicines = latest.medicines || '';
  //       //               queueItem.personal_dues = latest.personal_dues || 0;
  //       //               queueItem.visit_fees = latest.visit_fees || 0;
  //       //               queueItem.received_online = latest.received_online || 0;
  //       //               queueItem.received_cash = latest.received_cash || 0;
  //       //               queueItem.card_dues = latest.card_dues || 0;
  //       //             } else {
  //       //               queueItem.medicines = '';
  //       //               queueItem.history = [];
  //       //               queueItem.personal_dues = 0;
  //       //               queueItem.visit_fees = 0;
  //       //               queueItem.received_online = 0;
  //       //               queueItem.received_cash = 0;
  //       //               queueItem.card_dues = 0;
  //       //             }
  //       //           });
  //       //       });

  //       //       // ✅ Sort by appointment date then time
  //       //       // ✅ Sort by date/time (latest first, correct chronological order)
  //       //       this.allMedicineQueue.sort((a, b) => {
  //       //         const dateA = new Date(a.raw_date || a.date);
  //       //         const dateB = new Date(b.raw_date || b.date);

  //       //         const dateCompare = dateB.getTime() - dateA.getTime(); // descending order
  //       //         if (dateCompare !== 0) return dateCompare;

  //       //         const timeA = a.time.padStart(5, '0');
  //       //         const timeB = b.time.padStart(5, '0');
  //       //         return timeB.localeCompare(timeA); // descending (latest first)
  //       //       });
  //       //     }
  //       //   });

  //       this.patientRegistrationService.getPatientsBatch(patientIds)
  //         .subscribe((patientRes: any) => {
  //           if (!(patientRes.success && patientRes.data)) return;

  //           const patientsMap = new Map(patientRes.data.map((p: any) => [p.id, p]));

  //           // Merge data -> Initial queue list
  //           this.allMedicineQueue = appointments.map((appt: any) => {
  //             const p: any = patientsMap.get(appt.patient_id);
  //             return {
  //               id: p.id,
  //               appointment_id: appt.appointment_id,
  //               clinic_id: appt.clinic_id,
  //               doctor_id: appt.doctor_id,
  //               prescription_id: appt.prescription_id,
  //               name: `${p.salutation} ${p.full_name}`,
  //               full_name: p.full_name,
  //               time: appt.time,
  //               date: appt.date,
  //               formatdate: appt.formatdate,
  //               status: appt.status,
  //               medicine_collection: appt.medicine_collection,
  //               contact_number: p.contact_number,
  //               is_free: p.is_free,
  //               card_id: p.card_id,
  //               age: p.age,
  //               referred_by: p.referred_by,
  //               referred_by_dr: p.referred_by_dr,
  //               occupation: p.occupation,
  //               medicines: '',
  //               personal_dues: 0,
  //               visit_fees: 0,
  //               received_online: 0,
  //               received_cash: 0,
  //               card_dues: 0,
  //               history: []
  //             };
  //           });

  //           // 🔥 Use SINGLE batch request instead of 50 API calls
  //           this.prescriptionsService.getLatestBatch(patientIds).subscribe((presRes: any) => {
  //             if (presRes.success && presRes.data) {
  //               const latestMap = new Map(presRes.data.map((p: any) =>
  //                 [p.appointment?.patient_id, p]
  //               ));

  //               this.allMedicineQueue = this.allMedicineQueue.map(item => {
  //                 const latest: any = latestMap.get(item.id);
  //                 return {
  //                   ...item,
  //                   medicines: latest?.medicines || '',
  //                   personal_dues: latest?.personal_dues || 0,
  //                   visit_fees: latest?.visit_fees || 0,
  //                   received_online: latest?.received_online || 0,
  //                   received_cash: latest?.received_cash || 0,
  //                   card_dues: latest?.card_dues || 0,
  //                   is_courier: latest?.is_courier || false,
  //                   notes: latest?.notes || '',
  //                   history: []  // Load only when needed separately
  //                 };
  //               });

  //               // Final sorting (if needed)
  //               this.allMedicineQueue.sort((a, b) => {
  //                 const d1 = new Date(a.date);
  //                 const d2 = new Date(b.date);
  //                 return d2.getTime() - d1.getTime() || b.time.localeCompare(a.time);
  //               });
  //             }
  //           });
  //       });


  //     } else {
  //       this.allMedicineQueue = [];
  //       this.toaster.add({
  //         severity: 'info',
  //         summary: 'No Records',
  //         detail: 'No patients in medicine queue.',
  //       });
  //     }
  //   });
  // }

  loadAllMedicineQueue() {
    const clinicId = this.workContext.getClinicIdString();
    const doctorId = this.workContext.getDoctorIdString();

    if (!clinicId || !doctorId) {
      this.toaster.warn('Select clinic and doctor', 'Missing Selection');
      return;
    }

    this.appointmentService.getAllMedicineQueue({ clinic_id: clinicId, doctor_id: doctorId })
      .subscribe((res: any) => {
        // Support two common response shapes: { success:true, data: { appointments: [...] } }
        // and { success:true, data: [...] }
        const dataArr: any[] = Array.isArray(res.data)
          ? res.data
          : Array.isArray(res.data?.appointments)
            ? res.data.appointments
            : [];

        if (!res.success || dataArr.length === 0) {
          this.allMedicineQueue = [];
          return;
        }

        // Normalize various field names from backend (id vs appointment_id, start_time vs appointment_time)
        this.allMedicineQueue = dataArr.map((a: any) => {
          const apptId = a.appointment_id ?? a.id ?? a.appointmentId ?? a.appointment?.id;
          const apptDate = a.appointment_date ?? a.date ?? a.appointment?.date;
          const apptTime = a.appointment_time ?? a.start_time ?? a.time ?? a.appointment?.time;
          const patientObj = a.patient ?? a.patient_data ?? a.patient_details ?? a.patientInfo ?? a.patient?.data;

          return {
            appointment_id: apptId,
            date: apptDate,
            time: apptTime,
            formatdate: this.formatDate(apptDate),
            status: a.status ?? a.state ?? '',
            medicine_collection: a.medicine_collection ?? a.medicineCollection ?? false,

            patient_id: patientObj?.id ?? a.patient_id ?? a.patientId ?? null,
            name: `${patientObj?.salutation ?? ''} ${patientObj?.full_name ?? patientObj?.name ?? ''}`.trim(),
            full_name: patientObj?.full_name ?? patientObj?.name ?? '',
            patient_number: patientObj?.patient_number ?? a.patient_number ?? '',
            card_number: (patientObj?.patient_number ?? a.patient_number ?? '').split('-')[0] ?? '',
            contact_number: patientObj?.contact_number ?? patientObj?.phone ?? '',
            card_id: patientObj?.card_id ?? '',
            age: patientObj?.age ?? 0,
            is_free: patientObj?.is_free ?? false,

            medicines: '',
            personal_dues: 0,
            visit_fees: 0,
            received_cash: 0,
            received_online: 0,
            card_dues: 0,
            notes: '',
            delivery_type: a.delivery_type ?? (a.is_courier || a.isCourier ? 'home_delivery' : null),
            is_courier: a.is_courier ?? a.isCourier ?? false
          };
        });

        // Build appointment id list and filter out falsy ids
        const appointmentIds = this.allMedicineQueue.map(q => q.appointment_id).filter((id: any) => id != null);
        // console.log('appointmentIds:', appointmentIds);

        if (appointmentIds.length === 0) return; // nothing to fetch

        // Fetch prescriptions by appointment IDs
        this.prescriptionsService.getPrescriptionsByAppointments(appointmentIds)
          .subscribe((presRes: any) => {
            if (!presRes.success || !Array.isArray(presRes.data)) return;

            const map = new Map(
              presRes.data.map((p: any) => [p.appointment_id ?? p.appointmentId ?? p.appointment?.id, p])
            );

            this.allMedicineQueue = this.allMedicineQueue.map(item => {
              const key = item.appointment_id;
              const p = map.get(key);
              return p ? { ...item, ...p } : item;
            });

            // Final sort (safely handle missing date/time)
            this.allMedicineQueue.sort((a, b) => {
              const tA = new Date((a.date ?? '') + ' ' + (a.time ?? ''))?.getTime() || 0;
              const tB = new Date((b.date ?? '') + ' ' + (b.time ?? ''))?.getTime() || 0;
              return tB - tA;
            });
          });
      });
  }

  public formatTime = formatDisplayTime;

  shouldShowWaitingBadge(item: any): boolean {
    const status = (item?.status || '').toLowerCase();
    return (status === 'checked in' || status === 'in progress') && !!this.getCheckInTimestamp(item);
  }

  formatWaitingTime(item: any): string {
    void this.waitingTimeTick;

    const start = this.getCheckInTimestamp(item);
    if (!start) {
      return '';
    }

    const elapsedMs = Math.max(0, Date.now() - start);
    const totalMinutes = Math.floor(elapsedMs / 60000);

    if (totalMinutes < 1) {
      return '<1 min';
    }

    if (totalMinutes < 60) {
      return `${totalMinutes} min`;
    }

    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;
    return minutes > 0 ? `${hours}h ${minutes}m` : `${hours}h`;
  }

  isWaitingUrgent(item: any): boolean {
    void this.waitingTimeTick;
    const start = this.getCheckInTimestamp(item);
    if (!start) {
      return false;
    }
    return Date.now() - start >= 20 * 60 * 1000;
  }

  private getCheckInTimestamp(item: any): number | null {
    if (!item?.checked_in_at) {
      return null;
    }

    const timestamp = new Date(item.checked_in_at).getTime();
    return Number.isNaN(timestamp) ? null : timestamp;
  }

  /**
   * ✅ Format date to “8th Nov 25”
   */
  private formatDate(dateStr: string): string {
    if (!dateStr) return '';
    const date = new Date(dateStr);
    const day = date.getDate();
    const month = date.toLocaleString('en-US', { month: 'short' });
    const year = date.getFullYear().toString().slice(-2);
    const suffix = this.getOrdinalSuffix(day);
    return `${day}${suffix} ${month} ${year}`;
  }

  /**
   * Helper to add correct suffix (st, nd, rd, th)
   */
  private getOrdinalSuffix(day: number): string {
    if (day > 3 && day < 21) return 'th';
    switch (day % 10) {
      case 1: return 'st';
      case 2: return 'nd';
      case 3: return 'rd';
      default: return 'th';
    }
  }

  searchPatients(event: any) {
    const query = event.query;
    this.http.get<any>(this.apiUrl + '/patient/search', { params: { q: query }, ...this.getAuthHeaders()})
      .subscribe(res => {
        if (!res.data || res.data.length === 0) {
          this.patientsList = [];
          this.toaster.add({
            severity: 'info',
            summary: 'Info',
            detail: `No patients found for "${query}".`
          });
        } else {
          this.patientsList = res.data.map((p: any) => ({
            ...p,
            full_name: `${p.full_name} (${p.patient_number})`
          }));
        }
        // Stop spinner and update view
        this.cdr.detectChanges();
      }, error => {
        this.patientsList = [];
        this.toaster.info('No patients found.', 'Info');
        this.cdr.detectChanges();
      });
  }

  showMedicineDialog(item: any) {
    const previous = this.getBlockingQueuePatient(item);
    if (previous) {
      this.pendingSwitchPatient = item;
      this.pendingPreviousPatient = previous;
      this.switchPatientConfirmVisible = true;
      return;
    }

    this.openDispenseDialog(item);
  }

  isQueuePatientLocked(item: any): boolean {
    return !!this.getBlockingQueuePatient(item);
  }

  cancelSwitchPatient(): void {
    this.switchPatientConfirmVisible = false;
    this.pendingSwitchPatient = null;
    this.pendingPreviousPatient = null;
  }

  get switchConfirmPreviousName(): string {
    return this.patientDisplayName(this.pendingPreviousPatient);
  }

  get switchConfirmCurrentName(): string {
    return this.patientDisplayName(this.pendingSwitchPatient);
  }

  get switchConfirmCurrentInitials(): string {
    return this.getDispenseInitials(this.switchConfirmCurrentName);
  }

  clearDeskChatPatient(): void {
    this.deskChat.setAttachablePatient(null);
  }

  private publishDeskChatPatient(item: any): void {
    const patientId = Number(item?.patient_id || 0);
    if (!patientId) {
      this.deskChat.setAttachablePatient(null);
      return;
    }
    this.deskChat.setAttachablePatient({
      id: patientId,
      full_name: item?.name || item?.full_name || 'Patient',
      patient_number: item?.patient_number || '',
      card_number: item?.card_number || '',
    });
  }

  private tryOpenDeskChatPatient(): boolean {
    const patientId = Number(this.pendingDeskPatientId || 0);
    if (!patientId) {
      return false;
    }
    const item = [...(this.queue || []), ...(this.completedQueue || [])]
      .find((entry: any) => Number(entry?.patient_id) === patientId);
    if (!item) {
      return false;
    }
    this.pendingDeskPatientId = null;
    this.awaitingDeskPatient = false;
    this.deskChat.clearOpenRequest();
    this.showMedicineDialog(item);
    return true;
  }

  private openDispenseDialog(item: any) {
    this.visible = true;
    this.selectedPatient = item;
    this.publishDeskChatPatient(item);
    this.selectedPatient.medicine_collection = !!this.selectedPatient.medicine_collection;
    this.selectedPatient.delivery_type = resolveDeliveryType(this.selectedPatient);
    this.selectedPatient.is_courier = !!this.selectedPatient.delivery_type;
    this.normalizePaymentFields(this.selectedPatient);
    delete this.selectedPatient._duesBaseline;
    delete this.selectedPatient._baseReceivedCash;
    delete this.selectedPatient._baseReceivedOnline;
    delete this.selectedPatient._baseVisitFees;
    this.initializeDuesBaseline(this.selectedPatient);
    this.updateDues();
  }

  private getBlockingQueuePatient(item: any): any | null {
    const list = this.allMedicineQueue || [];
    const index = list.findIndex((entry) => this.sameAppointment(entry, item));
    if (index <= 0) {
      return null;
    }

    return list.slice(0, index).find((entry) => !this.isAppointmentComplete(entry)) || null;
  }

  private isAppointmentComplete(item: any): boolean {
    return String(item?.status || '').toLowerCase() === 'completed';
  }

  private sameAppointment(left: any, right: any): boolean {
    const leftId = left?.appointment_id ?? left?.id;
    const rightId = right?.appointment_id ?? right?.id;
    return leftId != null && rightId != null && String(leftId) === String(rightId);
  }

  private patientDisplayName(item: any): string {
    return item?.name || item?.full_name || 'this patient';
  }

  setDialogMedicineCollection(active: boolean) {
    if (!this.selectedPatient) {
      return;
    }

    this.selectedPatient.medicine_collection = !!active;
    if (this.selectedPatient.medicine_collection) {
      this.selectedPatient.delivery_type = null;
      this.selectedPatient.is_courier = false;
    }
    this.persistAppointmentMedicineCollection(this.selectedPatient).subscribe();
  }

  isDialogDeliveryTypeActive(type: DeliveryType): boolean {
    return resolveDeliveryType(this.selectedPatient) === type;
  }

  setDialogDeliveryType(type: DeliveryType) {
    if (!this.selectedPatient) {
      return;
    }

    const current = resolveDeliveryType(this.selectedPatient);
    const next: DeliveryType | null = current === type ? null : type;
    this.selectedPatient.delivery_type = next;
    this.selectedPatient.is_courier = !!next;
    if (next) {
      this.selectedPatient.medicine_collection = false;
    }
    this.persistAppointmentDeliveryType(this.selectedPatient).subscribe();
  }

  getDeliveryType(item: any): DeliveryType | null {
    return resolveDeliveryType(item);
  }

  getDeliveryBadgeLabel(item: any): string {
    return deliveryTypeLabel(resolveDeliveryType(item));
  }

  getDeliveryBadgeShort(item: any): string {
    return deliveryTypeShortLabel(resolveDeliveryType(item));
  }

  getDeliveryBadgeIcon(item: any): string {
    return deliveryBadgeIcon(resolveDeliveryType(item));
  }

  getMedicineIntentShort(value: MedicineIntent | null | undefined): string {
    return medicineIntentShortLabel(value);
  }

  getReceptionNoteTooltip(
    note: string | null | undefined,
    intent: MedicineIntent | null | undefined,
  ): string {
    return receptionNoteTooltip(note, intent);
  }

  getTotalReceived(patient: any): number {
    if (!patient) {
      return 0;
    }

    const cash = Number(patient.received_cash ?? 0) || 0;
    const online = Number(patient.received_online ?? 0) || 0;
    return cash + online;
  }

  formatRupee(value: number | string | null | undefined): string {
    const amount = Number(value ?? 0) || 0;
    return amount.toLocaleString('en-IN');
  }

  hasKeptBalance(patient: any): boolean {
    return (Number(patient?.personal_dues ?? 0) || 0) > 0;
  }

  getDispenseInitials(name: string | null | undefined): string {
    const salutations = new Set([
      'mr', 'mrs', 'ms', 'miss', 'shri', 'smt', 'ku', 'kumari', 'dr', 'prof', 'er', 'ca', 'adv',
    ]);
    const parts = (name || '')
      .trim()
      .split(/\s+/)
      .filter((part) => {
        const normalized = part.replace(/\.+$/g, '').toLowerCase();
        return normalized.length > 0 && !salutations.has(normalized);
      });
    if (!parts.length) {
      return '?';
    }
    if (parts.length === 1) {
      return parts[0].charAt(0).toUpperCase();
    }
    return `${parts[0].charAt(0)}${parts[parts.length - 1].charAt(0)}`.toUpperCase();
  }

  getDeliveryOptionHint(type: string): string {
    switch (type) {
      case 'home_delivery':
        return 'Send to patient address';
      case 'domestic':
        return 'Courier within India';
      case 'international':
        return 'Courier overseas';
      default:
        return '';
    }
  }

  getDispensePickupDate(patient: any): string {
    if (!patient) {
      return '—';
    }

    if (patient.formatdate) {
      return patient.formatdate;
    }

    if (patient.date) {
      return this.formatDateForDisplay(patient.date);
    }

    return '—';
  }

  formatDateForDisplay(dateStr: string): string {
    if (!dateStr) {
      return '—';
    }

    const normalized = String(dateStr).trim();
    if (/^\d{2}-\d{2}-\d{4}$/.test(normalized)) {
      return normalized;
    }

    const date = new Date(normalized);
    if (Number.isNaN(date.getTime())) {
      return normalized;
    }

    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  }

  private normalizePaymentFields(item: any) {
    if (!item) return;

    const cash = item.received_cash;
    const online = item.received_online;

    item.received_cash = (cash === null || cash === undefined || cash === '') ? 0 : (Number(cash) || 0);
    item.received_online = (online === null || online === undefined || online === '') ? 0 : (Number(online) || 0);
  }

  private initializeDuesBaseline(item: any) {
    if (!item) return;

    if (item._duesBaseline == null) {
      item._duesBaseline = Number(item.personal_dues ?? 0) || 0;
    }
    if (item._baseReceivedCash == null) {
      item._baseReceivedCash = Number(item.received_cash ?? 0) || 0;
    }
    if (item._baseReceivedOnline == null) {
      item._baseReceivedOnline = Number(item.received_online ?? 0) || 0;
    }
    if (item._baseVisitFees == null) {
      item._baseVisitFees = Number(item.visit_fees ?? 0) || 0;
    }
  }

  private buildPrescriptionPaymentPayload(item: any) {
    this.normalizePaymentFields(item);
    return {
      id: item?.prescription_id ?? item?.id,
      appointment_id: item?.appointment_id,
      received_cash: Number(item?.received_cash ?? 0),
      received_online: Number(item?.received_online ?? 0),
      visit_fees: Number(item?.visit_fees ?? 0),
      personal_dues: Number(item?.personal_dues ?? 0),
      delivery_type: item?.delivery_type ?? resolveDeliveryType(item),
      is_courier: !!resolveDeliveryType(item),
    };
  }

  private persistAppointmentDeliveryType(item: any) {
    const appointmentId = Number(item?.appointment_id || 0);
    if (!appointmentId) {
      return of({ success: true });
    }

    const deliveryType = resolveDeliveryType(item);
    return this.appointmentService.updateAppointment({
      id: appointmentId,
      delivery_type: deliveryType,
      is_courier: !!deliveryType,
    }).pipe(
      catchError((err) => {
        console.error('Error updating delivery type:', err);
        this.toaster.error('Failed to update delivery type.');
        return EMPTY;
      })
    );
  }

  private persistAppointmentMedicineCollection(item: any) {
    const appointmentId = Number(item?.appointment_id || 0);
    if (!appointmentId) {
      return of({ success: true });
    }

    return this.appointmentService.updateAppointment({
      id: appointmentId,
      medicine_collection: !!item?.medicine_collection
    }).pipe(
      catchError((err) => {
        console.error('Error updating medicine collection flag:', err);
        this.toaster.error('Failed to update medicine collection flag.');
        return EMPTY;
      })
    );
  }

  collectPaymentOnly(item: any) {
    if (this.warnIfCollectionExceedsCap(item)) {
      return;
    }
    if (!this.canCollectCashPayment(item)) {
      this.toaster.warn('Enter cash received or a kept balance before saving payment.', 'Amount required');
      return;
    }

    const payload = this.buildPrescriptionPaymentPayload(item);
    if (!payload.id) {
      this.toaster.error('Prescription is not available for payment update.');
      return;
    }

    this.persistAppointmentDeliveryType(item).pipe(
      switchMap(() => this.persistAppointmentMedicineCollection(item)),
      switchMap(() => this.prescriptionsService.updatePrescriptions(payload))
    ).subscribe({
      next: () => {
        this.initializeDuesBaseline(item);
        item._duesBaseline = Number(item.personal_dues ?? 0) || 0;
        item._baseReceivedCash = Number(item.received_cash ?? 0) || 0;
        item._baseReceivedOnline = Number(item.received_online ?? 0) || 0;
        item._baseVisitFees = Number(item.visit_fees ?? 0) || 0;
        this.loadAllMedicineQueue();
        this.loadQueue();
        this.toaster.success('Payment collected successfully without completing appointment.');
      },
      error: (err) => {
        console.error('Error collecting payment:', err);
        this.toaster.error(err?.error?.message || 'Failed to collect payment. Please try again.');
      }
    });
  }

  confirmCompleteAppointment(item: any) {
    this.pendingCompletePatient = item;
    this.completeConfirmVisible = true;
  }

  cancelCompleteAppointment(): void {
    this.completeConfirmVisible = false;
    this.pendingCompletePatient = null;
  }

  acceptCompleteAppointment(): void {
    const item = this.pendingCompletePatient;
    this.completeConfirmVisible = false;
    this.pendingCompletePatient = null;
    if (!item) {
      return;
    }
    this.changeStatus(item);
  }

  get completeConfirmPatientName(): string {
    return this.pendingCompletePatient?.name
      || this.pendingCompletePatient?.full_name
      || 'this patient';
  }

  get completeConfirmPatientInitials(): string {
    return this.getDispenseInitials(
      this.pendingCompletePatient?.name || this.pendingCompletePatient?.full_name || '',
    );
  }

  changeStatus(item: any) {
    if (!item?.appointment_id) {
      this.toaster.error('Missing appointment id.');
      return;
    }

    if (this.warnIfCollectionExceedsCap(item)) {
      return;
    }

    const payload = this.buildPrescriptionPaymentPayload(item);
    if (!payload.id) {
      this.toaster.error('Prescription is not available for status completion.');
      return;
    }

    this.persistAppointmentDeliveryType(item).pipe(
      switchMap(() => this.persistAppointmentMedicineCollection(item)),
      switchMap(() => this.appointmentService.changeStatus(item.appointment_id, 'completed')),
      switchMap((res: any) => {
        if (res.success) {
          return this.prescriptionsService.updatePrescriptions(payload);
        } 
        return EMPTY; // stops the chain if not successful
      })
    ).subscribe({
      next: () => {
        this.visible = false;
        this.loadAllMedicineQueue(); // Refresh only after prescriptions update
        this.loadQueue();
        this.toaster.success('Status updated successfully.');
      },
      error: (err) => {
        console.error('Error changing status or updating prescriptions:', err);
        this.toaster.error('Something went wrong. Please try again.');
      }
    });
  }

  changeStatusToCheckedIn(item: any) {
    this.requestCheckIn(item);
  }

  requestCheckIn(item: any, event?: Event) {
    event?.stopPropagation();

    if (!item?.appointment_id) {
      this.toaster.error('Missing appointment id.');
      return;
    }

    if (item.status === 'checked in' && !item._checkInPending) {
      this.toaster.info('Appointment is already checked in.', 'Info');
      return;
    }

    if (item._checkInPending) {
      return;
    }

    item._previousStatus = item.status || 'scheduled';
    item.status = 'checked in';
    item._checkInPending = true;

    const existingTimer = this.pendingCheckInTimers.get(item.appointment_id);
    if (existingTimer) {
      clearTimeout(existingTimer);
    }

    const timerId = setTimeout(() => this.commitCheckIn(item), this.checkInUndoMs);
    this.pendingCheckInTimers.set(item.appointment_id, timerId);

    this.toaster.add({
      severity: 'info',
      summary: 'Check-in queued',
      detail: `Undo within ${this.checkInUndoMs / 1000} seconds if needed.`
    });
  }

  undoCheckIn(item: any, event?: Event) {
    event?.stopPropagation();

    if (!item?._checkInPending) return;

    const timerId = this.pendingCheckInTimers.get(item.appointment_id);
    if (timerId) {
      clearTimeout(timerId);
      this.pendingCheckInTimers.delete(item.appointment_id);
    }

    item.status = item._previousStatus || 'scheduled';
    item._checkInPending = false;
    delete item._previousStatus;

    this.toaster.success('Check-in action was reverted.', 'Undone');
  }

  private commitCheckIn(item: any) {
    if (!item?._checkInPending || !item?.appointment_id) return;

    this.pendingCheckInTimers.delete(item.appointment_id);

    this.appointmentService.changeStatus(item.appointment_id, 'checked in').subscribe({
      next: (res: any) => {
        if (!res?.success) {
          item.status = item._previousStatus || 'scheduled';
          item._checkInPending = false;
          delete item._previousStatus;
          this.toaster.error('Failed to update status. Please try again.');
          return;
        }

        item._checkInPending = false;
        delete item._previousStatus;

        if (res?.data?.checked_in_at) {
          item.checked_in_at = res.data.checked_in_at;
        }

        this.toaster.success('Status updated to checked in successfully.', 'Checked In');

        this.loadQueue();
        this.appointmentCalendar?.loadEvents();
      },
      error: () => {
        item.status = item._previousStatus || 'scheduled';
        item._checkInPending = false;
        delete item._previousStatus;

        this.toaster.error('Something went wrong. Please try again.');
      }
    });
  }

  // calculatePersonalDues(records: any[], current: any): number {
  //   let lastDue = 0;

  //   if (records && records.length > 0) {
  //     // Find the most recent prescription with dues > 0
  //     const last = records.find((r: any) => r.personal_dues && r.personal_dues >= 0);
  //     if (last) {
  //       lastDue = Number(last.personal_dues);
  //     }
  //   }

  //   const visitFees = Number(current.visit_fees) || 0;
  //   const receivedCash = Number(current.received_cash) || 0;
  //   const receivedOnline = Number(current.received_online) || 0;

  //   return (lastDue - (receivedCash + receivedOnline));
  //   // return (visitFees - (receivedCash + receivedOnline)) + lastDue;
  // }

  updateDues() {
    this.normalizePaymentFields(this.selectedPatient);
    this.initializeDuesBaseline(this.selectedPatient);
    this.selectedPatient.personal_dues = this.calculatePersonalDues(
      this.selectedPatient.history,
      this.selectedPatient
    );
  }

  onCollectionAmountChange(field: 'received_cash' | 'received_online') {
    const item = this.selectedPatient;
    if (!item) {
      return;
    }

    this.normalizePaymentFields(item);
    const maximum = this.maximumCollectable(item);
    const cash = Number(item.received_cash) || 0;
    const online = Number(item.received_online) || 0;
    if (cash + online > maximum) {
      const other = field === 'received_cash' ? online : cash;
      item[field] = Math.max(0, maximum - other);
      this.toaster.warn(
        `Payment cannot exceed ₹${this.formatRupee(maximum)} (visit fees and outstanding dues).`,
        'Amount too high'
      );
    }
    this.updateDues();
  }

  onBalanceChange() {
    if (!this.selectedPatient) {
      return;
    }

    const dues = Number(this.selectedPatient.personal_dues ?? 0) || 0;
    this.selectedPatient.personal_dues = dues < 0 ? 0 : dues;
    this.normalizePaymentFields(this.selectedPatient);
    this.selectedPatient._duesBaseline = this.selectedPatient.personal_dues;
    this.selectedPatient._baseReceivedCash = Number(this.selectedPatient.received_cash ?? 0) || 0;
    this.selectedPatient._baseReceivedOnline = Number(this.selectedPatient.received_online ?? 0) || 0;
    this.selectedPatient._baseVisitFees = Number(this.selectedPatient.visit_fees ?? 0) || 0;
  }

  calculatePersonalDues(records: any[], current: any): number {
    if (!current) return 0;

    const hasBaseline =
      current._duesBaseline != null &&
      current._baseReceivedCash != null &&
      current._baseReceivedOnline != null &&
      current._baseVisitFees != null;

    if (hasBaseline) {
      const baselineDue = Number(current._duesBaseline) || 0;
      const baseCash = Number(current._baseReceivedCash) || 0;
      const baseOnline = Number(current._baseReceivedOnline) || 0;
      const baseVisitFees = Number(current._baseVisitFees) || 0;
      const visitFees = Number(current.visit_fees) || 0;
      const receivedCash = Number(current.received_cash) || 0;
      const receivedOnline = Number(current.received_online) || 0;
      const visitFeeDelta = visitFees - baseVisitFees;

      const finalDue = baselineDue + visitFeeDelta + (baseCash + baseOnline) - (receivedCash + receivedOnline);
      return finalDue > 0 ? finalDue : 0;
    }

    // find last saved dues
    let previousDue = 0;

    if (Array.isArray(records) && records.length > 0) {
      const lastRecord = [...records].reverse()
        .find(r => r.personal_dues != null && r.personal_dues !== '' && !isNaN(r.personal_dues));

      if (lastRecord) previousDue = Number(lastRecord.personal_dues);
    }

    const visitFees      = Number(current.visit_fees) || 0;
    const receivedCash   = Number(current.received_cash) || 0;
    const receivedOnline = Number(current.received_online) || 0;

    const totalPaid  = receivedCash + receivedOnline;
    const finalDue   = (previousDue + visitFees) - totalPaid;

    return finalDue > 0 ? finalDue : 0;  // no negative circus dues
  }

  public paymentResponse: any = null;

  //! Code Written By Bhargav
  private paymentListenerAttached = false;

  initiatePayment(selectedPatient: any) {
    if (this.warnIfCollectionExceedsCap(selectedPatient)) {
      return;
    }
    if (!this.canInitiateOnlinePayment(selectedPatient)) {
      this.toaster.warn('Enter online/UPI amount equal to or greater than visit fees before starting payment.', 'Online amount required');
      return;
    }

    // console.log('doctor_id from session', sessionStorage.getItem('doctor_id'));
    // console.log('selectedPatient', selectedPatient);
    const payload = {
      order_id: 'ORD' + new Date().getTime(),
      patient_id: selectedPatient.patient_id,
      appointment_id: selectedPatient.appointment_id,
      prescription_id: selectedPatient.id,
      // doctor_id: sessionStorage.getItem('doctor_id'),
      doctor_id: this.workContext.getDoctorId() ?? 0,
      name: selectedPatient.name,
      contact_number: selectedPatient.contact_number,
      amount: this.selectedPatient?.received_online ?? 0,
      amount_mode: 'total_online',
    };

    this.appointmentService.ccAvenuePayment(payload).subscribe((res: any) => {
      if (!res || !res.ccavenueUrl || !res.encRequest || !res.accessCode) {
        this.toaster.error('Invalid payment initialization response', 'Payment Error');
        return;
      }

      // ✅ Create form dynamically
      const form = document.createElement('form');
      form.method = 'POST';
      form.action = res.ccavenueUrl; // Do NOT append params manually
      form.target = 'paymentPopup';

      // ✅ Append required fields
      const fields = {
        encRequest: res.encRequest,
        access_code: res.accessCode
      };
      Object.entries(fields).forEach(([key, value]) => {
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = key;
        input.value = value as string;
        form.appendChild(input);
      });

      // ✅ Open popup first (to avoid blocked popup)
      const popup = window.open('', 'paymentPopup', 'width=800,height=600');
      if (!popup) {
        this.toaster.warn('Please allow popups to complete payment', 'Popup Blocked');
        return;
      }

      // ✅ Append form and submit
      document.body.appendChild(form);
      form.submit();
      form.remove();

      // ✅ Attach listener only ONCE
      if (!this.paymentListenerAttached) {
        this.paymentListenerAttached = true;

        window.addEventListener('message', (event) => {
          // const allowedOrigins = [this.apiUrl, 'http://localhost:8000'];
          const allowedOrigins = ['https://clinic.drsubodhbhade.com', window.location.origin];
          if (!allowedOrigins.includes(event.origin)) {
            console.warn('❌ Blocked message from untrusted origin:', event.origin);
            return;
          }

          const data = event.data;
          if (!data || typeof data !== 'object') {
            console.error('❌ Invalid message received:', data);
            return;
          }

          // ✅ Make it tolerant to either key
          const status = String(data.status || data.payment_status || '').trim().toLowerCase();

          if (!status) {
            console.warn('⚠️ No payment status received:', data);
            return;
          }

          switch (status) {
            case 'success':
              if (data?.amount != null && !isNaN(Number(data.amount))) {
                selectedPatient.received_online = Number(data.amount);
                this.updateDues();
              }
              this.toaster.success('Online payment was completed successfully', 'Payment Successful');
              this.collectPaymentOnly(selectedPatient);
              break;

            case 'failure':
              this.toaster.error('The transaction was unsuccessful. Please try again.', 'Payment Failed');
              break;

            case 'aborted':
              this.toaster.warn('You cancelled the payment before completion.', 'Payment Aborted');
              break;

            case 'invalid':
              this.toaster.error('Payment request was invalid or corrupted.', 'Invalid Payment');
              break;

              case 'timeout':
                this.toaster.warn('The payment session expired or timed out. Please try again.', 'Payment Timeout');
                break;

            default:
              this.toaster.info('Payment status: ' + status, 'Payment Status');
              break;
          }

          // popup?.close();
        });
      }
    }, (err: any) => {
      this.toaster.error(err?.error?.message || err?.error?.error || 'Could not start payment.', 'Payment Error');
    });
  }

  public isCashPaid(patient: any): boolean {
    if (!patient) return false;
    const rc = Number(patient.received_cash ?? 0);
    const ro = Number(patient.received_online ?? 0);
    const vf = Number(patient.visit_fees ?? 0);
    if (!Number.isFinite(rc) || !Number.isFinite(ro) || !Number.isFinite(vf)) return false;
    return vf > 0 && rc >= vf && ro <= 0;
  }

  public canCollectCashPayment(patient: any): boolean {
    if (!patient || patient.is_free) {
      return false;
    }

    const receivedCash = Number(patient.received_cash ?? 0) || 0;
    return receivedCash > 0 || this.hasKeptBalance(patient);
  }

  public canInitiateOnlinePayment(patient: any): boolean {
    if (!patient || patient.is_free) {
      return false;
    }

    const visitFees = Number(patient.visit_fees ?? 0) || 0;
    const receivedOnline = Number(patient.received_online ?? 0) || 0;
    return receivedOnline >= visitFees && !this.collectionExceedsCap(patient);
  }

  private previousPersonalDues(item: any): number {
    const records = Array.isArray(item?.history) ? item.history : [];
    const currentId = Number(item?.prescription_id || 0);
    const currentAppointmentId = Number(item?.appointment_id || 0);
    const previous = records.find((record: any) => {
      if (currentId > 0 && Number(record?.id) === currentId) {
        return false;
      }
      if (currentAppointmentId > 0 && Number(record?.appointment_id) === currentAppointmentId) {
        return false;
      }
      return true;
    });
    return Math.max(0, Number(previous?.personal_dues) || 0);
  }

  private maximumCollectable(item: any): number {
    const visitFees = Math.max(0, Number(item?.visit_fees) || 0);
    const hasBaseline =
      item?._duesBaseline != null &&
      item?._baseReceivedCash != null &&
      item?._baseReceivedOnline != null &&
      item?._baseVisitFees != null;
    const baseCash = hasBaseline ? Number(item._baseReceivedCash) || 0 : Number(item?.received_cash) || 0;
    const baseOnline = hasBaseline ? Number(item._baseReceivedOnline) || 0 : Number(item?.received_online) || 0;
    const baseFees = hasBaseline ? Number(item._baseVisitFees) || 0 : visitFees;
    const baseline = hasBaseline ? Number(item._duesBaseline) || 0 : Number(item?.personal_dues) || 0;
    let maximum = Math.max(this.previousPersonalDues(item) + visitFees, baseline + baseCash + baseOnline + (visitFees - baseFees));

    const cardDues = Math.max(0, Number(item?.card_dues) || 0);
    if (cardDues > 0) {
      const visitOnCard = Number(item?.prescription_id || 0) > 0;
      const cardCap = visitOnCard ? cardDues + baseCash + baseOnline : cardDues + visitFees;
      maximum = Math.min(maximum, cardCap);
    }

    return Math.max(0, Math.round(maximum));
  }

  private collectionExceedsCap(item: any): boolean {
    if (!item || item.is_free) {
      return false;
    }
    return this.getTotalReceived(item) > this.maximumCollectable(item);
  }

  private warnIfCollectionExceedsCap(item: any): boolean {
    if (!this.collectionExceedsCap(item)) {
      return false;
    }
    const maximum = this.maximumCollectable(item);
    this.toaster.warn(
      `Payment cannot exceed ₹${this.formatRupee(maximum)} (visit fees and outstanding dues).`,
      'Amount too high'
    );
    return true;
  }

  public isPaymentSettled(patient: any): boolean {
    if (!patient) return false;
    const rc = Number(patient.received_cash ?? 0);
    const ro = Number(patient.received_online ?? 0);
    const vf = Number(patient.visit_fees ?? 0);
    if (!Number.isFinite(rc) || !Number.isFinite(ro) || !Number.isFinite(vf)) return false;
    return vf > 0 && (rc + ro) >= vf;
  }

  public getPaymentBadgeLabel(patient: any): string {
    if (!this.isPaymentSettled(patient)) return '';
    const rc = Number(patient?.received_cash ?? 0);
    const ro = Number(patient?.received_online ?? 0);
    const vf = Number(patient?.visit_fees ?? 0);
    if (rc >= vf && ro <= 0) return 'Cash Paid';
    if (ro >= vf && rc <= 0) return 'Online Paid';
    return 'Paid';
  }

  openQueueSidebar() {
    this.consultationQueueSearchTerm = '';
    this.loadQueue();
    this.isPatientVisible = true;
    setTimeout(() => this.focusConsultationQueueSearch(), 150);
  }

  get consultationFlowCounts(): FlowCounts {
    const list = this.queue || [];
    return {
      all: list.length,
      medicine: list.filter((item: any) => !!item?.medicine_collection).length,
      normal: list.filter((item: any) => matchesFlowFilter(item, 'normal')).length,
      home_delivery: list.filter((item: any) => resolveDeliveryType(item) === 'home_delivery').length,
      domestic: list.filter((item: any) => resolveDeliveryType(item) === 'domestic').length,
      international: list.filter((item: any) => resolveDeliveryType(item) === 'international').length,
    };
  }

  get filteredConsultationQueue(): any[] {
    const term = (this.consultationQueueSearchTerm || '').trim().toLowerCase();
    return (this.queue || []).filter((item: any) =>
      matchesFlowFilter(item, this.consultationFlowFilter) &&
      this.matchesQueueSearch(item, term),
    );
  }

  clearConsultationQueueSearch(): void {
    this.consultationQueueSearchTerm = '';
    this.focusConsultationQueueSearch();
  }

  private focusConsultationQueueSearch(): void {
    this.consultationQueueSearchInput?.nativeElement?.focus();
  }

  get medicineQueueFlowCounts(): FlowCounts {
    const list = this.allMedicineQueue || [];
    return {
      all: list.length,
      medicine: list.filter((item: any) => !!item?.medicine_collection).length,
      normal: list.filter((item: any) => matchesFlowFilter(item, 'normal')).length,
      home_delivery: list.filter((item: any) => resolveDeliveryType(item) === 'home_delivery').length,
      domestic: list.filter((item: any) => resolveDeliveryType(item) === 'domestic').length,
      international: list.filter((item: any) => resolveDeliveryType(item) === 'international').length,
    };
  }

  get filteredMedicineCollectionQueue(): any[] {
    const term = (this.medicineQueueSearchTerm || '').trim().toLowerCase();
    return (this.allMedicineQueue || []).filter((item: any) =>
      matchesFlowFilter(item, this.medicineQueueFlowFilter) &&
      this.matchesQueueSearch(item, term),
    );
  }

  clearMedicineQueueSearch(): void {
    this.medicineQueueSearchTerm = '';
  }

  private matchesQueueSearch(item: any, term: string): boolean {
    if (!term) {
      return true;
    }

    const haystack = [
      item?.name,
      item?.full_name,
      item?.patient_number,
      item?.card_number,
      item?.card_id,
      item?.contact_number,
    ]
      .map((value) => String(value ?? '').toLowerCase())
      .join(' ');

    return haystack.includes(term);
  }

  openMedicineQueueSidebar() {
    this.medicineQueueSearchTerm = '';
    this.loadAllMedicineQueue();
    // this.loadMedicineQueue();
    this.isMedicineVisible = true;
  }
}
